import { TableConfigV2 } from 'hooks/useMuiTableBuilderV2';
import { HeaderCell } from 'components/Cells/HeaderCell';
import { columns, COLUMNS } from './columns';
import { TeamsV2CheckboxHeaderCell } from './HeaderCells/TeamsV2CheckboxHeaderCell';
import TeamsV2CheckboxCell from './DataCells/TeamsV2CheckboxCell';
import TeamsV2StatusCell from './DataCells/TeamsV2StatusCell';
import TeamsV2TextCell from './DataCells/TeamsV2TextCell';
import TeamsV2TagsCountCell from './DataCells/TeamsV2TagsCountCell';
import TeamsV2IntegrationsCountCell from './DataCells/TeamsV2IntegrationsCountCell';
import TeamsV2TeamNameCell from './DataCells/TeamsV2TeamNameCell';
import TeamsV2ExpandToggleCell from './DataCells/TeamsV2ExpandToggleCell';
import TeamsV2DetailsRowCell from './DataCells/TeamsV2DetailsRowCell';
import { EmptyCell } from 'components/Cells/EmptyCell';

export const ROW_TYPES = {
  HEADER: 'HEADER',
  DATA: 'DATA',
  DETAILS: 'DETAILS',
} as const;

export const getTableConfig = (): TableConfigV2 => {
  return {
    hasStickyHeader: true,
    tableHeaderTitle: '',
    rowTypes: ROW_TYPES,
    hideToolbar: false,
    columns,
    columnsMinWidth: {
      [COLUMNS.CHECKBOX]: 40,
      [COLUMNS.STATUS]: 120,
      [COLUMNS.TEAM_ID]: 120,
      [COLUMNS.TEAM_NAME]: 220,
      [COLUMNS.SCHEDULED_DEACTIVATION_TIME]: 220,
      [COLUMNS.EXPAND]: 40,
    },
    cellsByRowTypesAndColumns: {
      [ROW_TYPES.DATA]: {
        [COLUMNS.CHECKBOX]: TeamsV2CheckboxCell,
        [COLUMNS.EXPAND]: TeamsV2ExpandToggleCell,
        [COLUMNS.STATUS]: TeamsV2StatusCell,
        [COLUMNS.TEAM_NAME]: TeamsV2TeamNameCell,
        [COLUMNS.TEAM_ID]: TeamsV2TextCell,
        [COLUMNS.TENANT]: TeamsV2TextCell,
        [COLUMNS.REALM]: TeamsV2TextCell,
        [COLUMNS.INTEGRATIONS]: TeamsV2IntegrationsCountCell,
        [COLUMNS.TAGS]: TeamsV2TagsCountCell,
        [COLUMNS.SCHEDULED_DEACTIVATION_TIME]: TeamsV2TextCell,
      },
      [ROW_TYPES.HEADER]: {
        [COLUMNS.CHECKBOX]: TeamsV2CheckboxHeaderCell,
        [COLUMNS.EXPAND]: HeaderCell,
        [COLUMNS.STATUS]: HeaderCell,
        [COLUMNS.TEAM_NAME]: HeaderCell,
        [COLUMNS.TEAM_ID]: HeaderCell,
        [COLUMNS.TENANT]: HeaderCell,
        [COLUMNS.REALM]: HeaderCell,
        [COLUMNS.INTEGRATIONS]: HeaderCell,
        [COLUMNS.TAGS]: HeaderCell,
        [COLUMNS.SCHEDULED_DEACTIVATION_TIME]: HeaderCell,
      },
      [ROW_TYPES.DETAILS]: {
        // Only the first column will be rendered for DETAILS rows (full-width)
        [COLUMNS.CHECKBOX]: TeamsV2DetailsRowCell,
        [COLUMNS.EXPAND]: EmptyCell,
        [COLUMNS.STATUS]: EmptyCell,
        [COLUMNS.TEAM_NAME]: EmptyCell,
        [COLUMNS.TEAM_ID]: EmptyCell,
        [COLUMNS.TENANT]: EmptyCell,
        [COLUMNS.REALM]: EmptyCell,
        [COLUMNS.INTEGRATIONS]: EmptyCell,
        [COLUMNS.TAGS]: EmptyCell,
      },
    },
  };
};

export default getTableConfig;
